// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-products-hidden-phone-phone-bqzfw{cursor:pointer;font-weight:700;position:relative;width:-moz-fit-content;width:fit-content}.components-products-hidden-phone-phoneLink-bnnnz{color:#111;font-weight:700;text-decoration:none}.components-products-hidden-phone-shadow-jabew{box-shadow:inset -48px 0 20px 5px #fff;height:100%;position:absolute;right:0;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"phone": "components-products-hidden-phone-phone-bqzfw",
	"phoneLink": "components-products-hidden-phone-phoneLink-bnnnz",
	"shadow": "components-products-hidden-phone-shadow-jabew"
};
module.exports = ___CSS_LOADER_EXPORT___;
